import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { instanceOfDeprecatedEvent, instanceOfPeteEvent } from "@faire/web--source/common/batch-events/utils";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { PeteEventsQueue } from "./__internal__/PeteEventsQueue";
import { UserEventsQueue } from "./__internal__/UserEventsQueue";
/**
 * @deprecated use `useBatchEventsManager` or `withStores` instead
 */ export var BatchEventsManager = /*#__PURE__*/ function() {
    "use strict";
    function BatchEventsManager() {
        var _this = this;
        _class_call_check(this, BatchEventsManager);
        this.flush = function() {
            return Promise.all([
                _this._peteEventsQueue.flush(),
                _this._userEventsQueue.flush()
            ]);
        };
        this._peteEventsQueue = new PeteEventsQueue();
        this._userEventsQueue = new UserEventsQueue();
    }
    var _proto = BatchEventsManager.prototype;
    // eslint-disable-next-line @faire/prefer-arrow-methods
    _proto.enqueueEvent = function enqueueEvent(event) {
        var _this = this;
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                if (instanceOfDeprecatedEvent(event)) {
                    return [
                        2,
                        _this._userEventsQueue.enqueueEvent(event)
                    ];
                } else if (instanceOfPeteEvent(event)) {
                    return [
                        2,
                        _this._peteEventsQueue.enqueueEvent(event)
                    ];
                }
                return [
                    2
                ];
            });
        })();
    };
    return BatchEventsManager;
}();
BatchEventsManager.get = singletonGetter(BatchEventsManager);
